import React from 'react';
import styled from 'styled-components';

const StyledSideBoxMenuItem = styled.div`
    color: var(--text-primary);
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 2rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export interface SideBoxMenuItemProps extends React.HTMLAttributes<HTMLDivElement> {}

const SideBoxMenuItem: React.FC<SideBoxMenuItemProps> = ({ children, ...props }) => {
    return <StyledSideBoxMenuItem {...props}>{children}</StyledSideBoxMenuItem>;
};

export default SideBoxMenuItem;
